"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _vuex = require("vuex");

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _moment = _interopRequireDefault(require("moment"));

var _dateformart = require("@/utils/dateformart");

var _SummaryPopup = _interopRequireDefault(require("@/components/SummaryPopup"));

var _elementUi = require("element-ui");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// waves directive
// secondary package based on el-pagination
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: 'rechargeOrderHistory:view',
  mixins: [_CustomTableColumn.default],
  extends: _PermissionPage.default,
  components: {
    Pagination: _Pagination.default,
    PermissionSimplePage: _PermissionSimplePage.default,
    SummaryPopup: _SummaryPopup.default
  },
  directives: {
    waves: _waves.default
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['auditOptions', 'informationOptions', 'orderStateOption', 'currencyTypeOption', 'moneyTypeFromOption'])),
  data: function data() {
    return {
      controllerPath: "rechargeOrderHistory",
      dialogFormVisible: false,
      tableKey: 0,
      list: null,
      organizationOption: null,
      agentOption: null,
      channelOption: [],
      total: 0,
      listLoading: true,
      numberOfDecimal: 2,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        timeList: [],
        state: null,
        channelId: '',
        moneyTypeTo: null,
        agentId: '',
        organizationCode: '',
        orderNo: ''
      },
      formTemp: {
        id: "",
        orderNo: "",
        msgId: "",
        resMsg: "",
        notifyTime: "",
        notifyProperty: "",
        createTime: ""
      },
      viewSummary: false,
      summaryList: [],
      downloadLoading: false,
      multipleSelection: []
    };
  },
  created: function created() {
    this.getNumberOfDecimal();
    this.setDefaultTime();
    this.getOption();
    this.getList();
  },
  methods: {
    handleNullMoneyTypeTo: function handleNullMoneyTypeTo(row) {
      if (row == null) {
        return "";
      }

      if (row.moneyTypeTo == null) {
        return "";
      }

      if (row.processIncreaseAmount == null) {
        return "";
      }

      return row.processIncreaseAmount + " " + row.moneyTypeTo;
    },
    getIncreaseAmount: function getIncreaseAmount(row) {
      if (row.processRechargeAmount == null || row.processAgentIncome == null || row.processChannelIncome == null || row.processProfit == null) {
        return 0;
      }

      var increaseAmount = parseFloat(row.processRechargeAmount) - parseFloat(row.processAgentIncome) - parseFloat(row.processChannelIncome) - parseFloat(row.processProfit);

      if (row.processUpAgentIncome != null) {
        increaseAmount = increaseAmount - parseFloat(row.processUpAgentIncome);
      }

      return parseFloat(increaseAmount).toFixed(this.numberOfDecimal);
    },
    convertCurrencyCodeToName: function convertCurrencyCodeToName(code) {
      var found = code;
      this.currencyTypeOption.forEach(function (status) {
        if (status.key == code) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertOrgCodeToName: function convertOrgCodeToName(code) {
      var found = code;
      this.organizationOption.forEach(function (status) {
        if (status.organizationCode == code) {
          found = status.organizationName;
          return;
        }
      });
      return found;
    },
    convertChannelIdToName: function convertChannelIdToName(code) {
      var found = "";
      this.channelOption.forEach(function (status) {
        if (parseInt(status.channelId) == code) {
          found = status.channelName;
          return;
        }
      });
      return found;
    },
    convertAgentIdToName: function convertAgentIdToName(code) {
      var found = "";
      this.agentOption.forEach(function (status) {
        if (parseInt(status.agentId) == code) {
          found = status.agentName;
          return;
        }
      });
      return found;
    },
    setDefaultTime: function setDefaultTime() {
      var a = new Date(Date.now());
      a.setHours(0, 0, 0, 0);
      var b = new Date(Date.now());
      b.setHours(23, 59, 59, 0);
      this.queryParameter.timeList = [this.dateFormat(a), this.dateFormat(b)];
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      var params = this.getQueryParams();

      _httpUtils.default.post(this.controllerPath, "list", null, params).then(function (res) {
        //let index;
        _this.viewSummary = false;
        _this.summaryList = [];
        _this.list = res.data.rows;
        _this.total = res.data.total;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    getOption: function getOption() {
      var _this2 = this;

      if (this.$store.getters.isAdmin) {
        _httpUtils.default.post("agent", "getAgents", null, null).then(function (agent) {
          _this2.agentOption = agent.data;
        }).catch(function (err) {
          _this2.$notify({
            title: _this2.$t("common.error"),
            message: _this2.$t("common.fetchError") + ',' + err.message,
            type: "error"
          });
        });
      }

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, {}).then(function (res) {
        _this2.channelOption = res.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });

      _httpUtils.default.post("organization", "getOrgs", null, null).then(function (res) {
        _this2.organizationOption = res.data;
      }).catch(function (err) {
        _this2.$notify({
          title: _this2.$t("common.error"),
          message: _this2.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    getQueryParams: function getQueryParams() {
      var startTime, endTime, state;

      if (!this.queryParameter.timeList) {
        startTime = (0, _dateformart.getYesterday)();
        endTime = (0, _dateformart.getYesterdayEnd)();
      } else {
        startTime = this.queryParameter.timeList[0];
        endTime = this.queryParameter.timeList[1];
      }

      if (this.queryParameter.state !== null) {
        state = this.queryParameter.state;
      }

      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        startTime: startTime,
        endTime: endTime,
        state: state,
        orderNo: this.queryParameter.orderNo,
        agentId: this.queryParameter.agentId,
        organizationCode: this.queryParameter.organizationCode,
        moneyTypeTo: this.queryParameter.moneyTypeTo,
        channelId: this.queryParameter.channelId
      };
    },
    resetFormTemp: function resetFormTemp() {
      this.formTemp.id = "", this.formTemp.orderNo = "", this.formTemp.msgId = "", this.formTemp.resMsg = "", this.formTemp.notifyTime = "", this.formTemp.notifyProperty = "", this.formTemp.createTime = "", this.dialogFormVisible = false;
    },
    getRowData: function getRowData(row) {
      this.formTemp = {
        id: row.id,
        orderNo: row.orderNo,
        msgId: row.msgId,
        resMsg: row.resMsg,
        notifyTime: row.notifyTime,
        notifyProperty: row.notifyProperty,
        createTime: row.createTime
      };
    },
    handlePresentData: function handlePresentData(val) {
      var _this3 = this;

      this.resetFormTemp();

      _httpUtils.default.post("rechargeOrderNotifyHistory", "getNotify", null, val).then(function (res) {
        if (res.data && res.data.length >= 1) {
          _this3.dialogFormVisible = true;

          _this3.getRowData(res.data[0]);
        }
      }).catch(function (err) {
        _this3.$notify({
          title: _this3.$t("common.error"),
          message: _this3.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      });
    },
    handleFilter: function handleFilter() {
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getStatistic: function getStatistic() {
      var _this4 = this;

      var params = this.getQueryParams();

      _httpUtils.default.post(this.controllerPath, "sum", null, params).then(function (res) {
        var data = res.data;
        _this4.summaryList = [[{
          label: 'SMS.totalText',
          value: data.total.total || 0,
          unit: ""
        }], [{
          label: 'rechargeState.createSuccess',
          value: data.total.totalReceiveSuccess || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.createFail',
          value: data.total.totalReceiveFail || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.submitSuccess',
          value: data.total.totalSubmitSuccess || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.submitFail',
          value: data.total.totalSubmitFail || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.notifySuccess',
          value: data.total.totalRechargeSuccess || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.notifyFail',
          value: data.total.totalRechargeFail || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.refund',
          value: data.total.totalRefund || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.credited',
          value: data.total.totalDeposited || 0,
          unit: 'SMS.tiao'
        }, {
          label: 'rechargeState.credited',
          value: data.total.totalUnknown || 0,
          unit: 'SMS.tiao'
        }]]; // if (this.$store.getters.isAdmin) {
        //
        //   if (data.dataList.currency === "USD") {
        //     this.summaryList.push(
        //       [
        //         {
        //           label: "common.USD",
        //           value: data.dataList.processedTotalMoneyTo || 0,
        //           unit: 'USD'
        //         },
        //         {
        //           label: "SMS.increaseAmount",
        //           value: data.dataList.processedTotalRechargeAmount || 0,
        //           unit: 'USD'
        //         },
        //         {
        //           label: "SMS.channelCost",
        //           value: data.dataList.processedTotalChannelIncome || 0,
        //           unit: 'USD'
        //         },
        //         {
        //           label: "SMS.agencyProfit",
        //           value: data.dataList.processedTotalAgentIncome || 0,
        //           unit: 'USD'
        //         },
        //         {
        //           label: "SMS.upAgencyProfit",
        //           value: data.dataList.processedTotalUpAgentIncome || 0,
        //           unit: 'USD'
        //         },
        //         {
        //           label: "SMS.profit",
        //           value: data.dataList.processedTotalProfit || 0,
        //           unit: 'USD'
        //         },
        //       ]
        //     )
        //   }
        //   if (data.dataList.currency === "CNY") {
        //     this.summaryList.push(
        //       [
        //         {
        //           label: "common.CNY",
        //           value: data.dataList.processedTotalMoneyTo || 0,
        //           unit: 'CNY'
        //         },
        //         {
        //           label: "SMS.increaseAmount",
        //           value: data.dataList.processedTotalRechargeAmount || 0,
        //           unit: 'CNY'
        //         },
        //         {
        //           label: "SMS.channelCost",
        //           value: data.dataList.processedTotalChannelIncome || 0,
        //           unit: 'CNY'
        //         },
        //         {
        //           label: "SMS.agencyProfit",
        //           value: data.dataList.processedTotalAgentIncome || 0,
        //           unit: 'CNY'
        //         },
        //         {
        //           label: "SMS.upAgencyProfit",
        //           value: data.dataList.processedTotalUpAgentIncome || 0,
        //           unit: 'CNY'
        //         },
        //         {
        //           label: "SMS.profit",
        //           value: data.dataList.processedTotalProfit || 0,
        //           unit: 'CNY'
        //         }
        //       ]
        //     )
        //   }
        //   if (data.dataList.currency === "HKD") {
        //     this.summaryList.push(
        //       [
        //         {
        //           label: "common.HKD",
        //           value: data.dataList.processedTotalMoneyTo || 0,
        //           unit: 'HKD'
        //         },
        //         {
        //           label: "SMS.increaseAmount",
        //           value: data.dataList.processedTotalRechargeAmount || 0,
        //           unit: 'HKD'
        //         },
        //         {
        //           label: "SMS.channelCost",
        //           value: data.dataList.processedTotalChannelIncome || 0,
        //           unit: 'HKD'
        //         },
        //         {
        //           label: "SMS.agencyProfit",
        //           value: data.dataList.processedTotalAgentIncome || 0,
        //           unit: 'HKD'
        //         },
        //         {
        //           label: "SMS.upAgencyProfit",
        //           value: data.dataList.processedTotalUpAgentIncome || 0,
        //           unit: 'HKD'
        //         },
        //         {
        //           label: "SMS.profit",
        //           value: data.dataList.processedTotalProfit || 0,
        //           unit: 'HKD'
        //         }
        //       ]
        //     )
        //   }
        // }
        // if (this.$store.getters.isAgent) {
        //   this.summaryList.push(
        //     [
        //       {
        //         label: "SMS.amountOfConsumption",
        //         value: data.rechargeAmount || 0,
        //         unit: 'USD'
        //       },
        //       {
        //         label: "SMS.agencyProfit",
        //         value: data.agentIncome || 0,
        //         unit: 'USD'
        //       },
        //       ]
        //   )
        // }
      }).catch(function (err) {
        _this4.$notify({
          title: _this4.$t("common.error"),
          message: _this4.$t("common.fetchError") + ',' + err.message,
          type: "error"
        });
      }).finally(function () {
        if (_this4.viewSummary == true) {
          _this4.viewSummary = false;
        } else {
          _this4.viewSummary = true;
        }
      });
    },
    handleExportReport: function handleExportReport() {
      var excelName = _lang.default.t("route.orderRecordsReport") + ".xlsx";
      var params = this.getQueryParams(); // httpUtils.getByBlob("statisticalChannel", "excel", params, excelName);

      _httpUtils.default.getByBlob(this.controllerPath, "excel", params, excelName); // MessageBox.confirm(
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateMessage"),
      //   i18n.t("warningMessage.pleaseWaitForExportAndNavigateTitle"),
      //   {
      //     confirmButtonText: i18n.t("warningMessage.exportAndNavigateConfirmButtonText"),
      //     cancelButtonText: i18n.t("warningMessage.exportAndNavigateCancelButtonText"),
      //     type: 'warning'
      //   }
      // ).then(() => {
      //   // route to exported excel page
      //   this.$router.push({
      //     name: "exportedExcel:view"
      //   });
      // }).catch(() => null);

    },
    rechargeStateCodeConvert: function rechargeStateCodeConvert(state) {
      var found = state;
      this.orderStateOption.forEach(function (status) {
        if (parseInt(status.key) == state) {
          found = status.name;
          return;
        }
      });
      return found;
    },
    dateFormat: function dateFormat(date) {
      if (date == undefined || date == '-') {
        return "-";
      }

      return (0, _moment.default)(date).format("YYYY-MM-DD HH:mm:ss");
    },
    getNumberOfDecimal: function getNumberOfDecimal() {
      var _this5 = this;

      _httpUtils.default.post("agentCost", "getNumberOfDecimal", {}, null).then(function (res) {
        _this5.numberOfDecimal = res.data.numberOfDecimal;
      }).catch(function (err) {
        _this5.$message({
          message: err.message,
          type: 'error'
        });
      });
    }
  }
};
exports.default = _default;